module.exports = __webpack_public_path__ + "static/media/IMG_0558.156785c7.JPG";